import { Component, OnInit, input, output, ChangeDetectionStrategy } from '@angular/core';
import { PropertySearch } from '../../models/propertyFilterParameters';

@Component({ standalone: false,
  selector: 'app-properties-search-results-filters',
  templateUrl: './properties-search-results-filters.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./properties-search-results-filters.component.scss']
})
export class PropertiesSearchResultsFiltersComponent implements OnInit {
  readonly presetPropertySearch = input<PropertySearch|undefined>(undefined);
  readonly onRemoveSearchField = output<any>();
  constructor() { }

  ngOnInit() { }

  public remove(field:any){
    this.onRemoveSearchField.emit(field);
  }

}